/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKeyScope } from './ApiKeyScope';
import {
    ApiKeyScopeFromJSON,
    ApiKeyScopeFromJSONTyped,
    ApiKeyScopeToJSON,
    ApiKeyScopeToJSONTyped,
} from './ApiKeyScope';

/**
 * 
 * @export
 * @interface CreatedApiKey
 */
export interface CreatedApiKey {
    /**
     * 
     * @type {number}
     * @memberof CreatedApiKey
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CreatedApiKey
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof CreatedApiKey
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CreatedApiKey
     */
    name: string;
    /**
     * First characters of the key for identification (the full key is never returned again)
     * @type {string}
     * @memberof CreatedApiKey
     */
    keyPrefix: string;
    /**
     * 
     * @type {Array<ApiKeyScope>}
     * @memberof CreatedApiKey
     */
    scopes: Array<ApiKeyScope>;
    /**
     * 
     * @type {Date}
     * @memberof CreatedApiKey
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatedApiKey
     */
    lastUsedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreatedApiKey
     */
    revokedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreatedApiKey
     */
    expiresAt?: Date | null;
    /**
     * Plaintext API key. Shown exactly once — store it securely.
     * @type {string}
     * @memberof CreatedApiKey
     */
    key: string;
}

/**
 * Check if a given object implements the CreatedApiKey interface.
 */
export function instanceOfCreatedApiKey(value: object): value is CreatedApiKey {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('keyPrefix' in value) || value['keyPrefix'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function CreatedApiKeyFromJSON(json: any): CreatedApiKey {
    return CreatedApiKeyFromJSONTyped(json, false);
}

export function CreatedApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedApiKey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'companyId': json['companyId'],
        'name': json['name'],
        'keyPrefix': json['keyPrefix'],
        'scopes': ((json['scopes'] as Array<any>).map(ApiKeyScopeFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : (new Date(json['lastUsedAt'])),
        'revokedAt': json['revokedAt'] == null ? undefined : (new Date(json['revokedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'key': json['key'],
    };
}

export function CreatedApiKeyToJSON(json: any): CreatedApiKey {
    return CreatedApiKeyToJSONTyped(json, false);
}

export function CreatedApiKeyToJSONTyped(value?: CreatedApiKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'companyId': value['companyId'],
        'name': value['name'],
        'keyPrefix': value['keyPrefix'],
        'scopes': ((value['scopes'] as Array<any>).map(ApiKeyScopeToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastUsedAt': value['lastUsedAt'] == null ? undefined : ((value['lastUsedAt'] as any).toISOString()),
        'revokedAt': value['revokedAt'] == null ? undefined : ((value['revokedAt'] as any).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'key': value['key'],
    };
}

